import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import routePaths from 'routePaths';
import LoginPage from 'modules/LoginPage';
import Home from 'modules/Home';
import CustomSecureRoute from 'sharedComponents/CustomSecureRoute/Index';

const AuthenticationPage = () => {
	const history = useHistory();

	return (
		<Switch>
			{/* Login */}
			<Route path={routePaths.loginPage} exact>
				<LoginPage />
			</Route>

			{/* Home */}
			<CustomSecureRoute path={routePaths.home}>
				<Home />
			</CustomSecureRoute>

			{/* TODO: remove this post MDM fix  */}
			<CustomSecureRoute path="/telematics" exact>
				<Redirect
					push
					to={{
						pathname: routePaths.telematics,
						search: history.location.search,
					}}
				/>
			</CustomSecureRoute>

			{/* TODO: Add 404 error page */}
			{/* FALLBACK */}
			<CustomSecureRoute path="*">
				<Redirect push to={routePaths.loginPage} />
			</CustomSecureRoute>
		</Switch>
	);
};

export default AuthenticationPage;
